export default __webpack_public_path__ + "static/media/tick.b7558125.svg";